/* Auro & Co product page helpers (loaded by sections/main-product.liquid, auro-related.liquid, auro-recently-viewed.liquid).
   1. "Goes well with" add-ons (snippets/auro-pdp-addons.liquid): Shopify complementary products first, else the rows the
      server rendered from the pairing rules. Ticking updates the main button to "Add 3 to basket · £X"; the product and the
      ticked items then go into the basket in one /cart/add.js request, and the cart drawer updates the Dawn way.
   2. Free delivery nudge (snippets/auro-pdp-delivery.liquid), refreshed from /cart.js after any add.
   3. "You may also like" (sections/auro-related.liquid): Shopify related recommendations, fetched when near the screen.
   4. "Recently viewed" (sections/auro-recently-viewed.liquid): handles in localStorage, cards via sections/auro-rv-card.liquid.
   5. Sticky Add to basket bar on phones (snippets/auro-pdp-sticky.liquid).
   6. Shopify customer events (custom): auro_pdp_addon_view, auro_pdp_addon_add, auro_pdp_related_add, auro_pdp_gift_link,
      auro_pdp_category_click (type: breadcrumb, view_all, chip or card).
   7. Breadcrumbs (snippets/auro-pdp-breadcrumbs.liquid) and "More in [Collection]" (sections/auro-more-in.liquid): when
      the shopper came from a collection page card (sessionStorage auro_pdp_from, written by assets/auro-cards.js),
      "More in" is re-rendered through that collection's address and the breadcrumb takes its name and link.
   Quick Add on cards and the "Added to your basket" message stay in assets/auro-cards.js. */
(function () {
  if (window.__auroPdp) return;
  window.__auroPdp = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
  var money;
  try { money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency }); } catch (e) { money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }); }
  var fmt = function (pence) { return money.format((Number(pence) || 0) / 100); };
  var STORE_KEY = 'auro_recently_viewed';

  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML.replace(/"/g, '&quot;'); }
  function track(name, data) {
    try {
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') a.publish(name, data);
    } catch (e) { /* tracking must never break the page */ }
  }
  function onPub(evt, fn) {
    try {
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS[evt]) return window.subscribe(window.PUB_SUB_EVENTS[evt], fn);
    } catch (e) { /* no pub/sub on this page */ }
    return null;
  }
  function near(el, fn) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); fn(); }
    }, { rootMargin: '600px 0px' });
    io.observe(el);
  }

  /* ---------- basket state (shared) ---------- */
  var cartListeners = [];
  var cartTimer = null;
  function refreshCart() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { cartListeners.forEach(function (fn) { try { fn(cart); } catch (e) { /* keep going */ } }); })
        .catch(function () {});
    }, 150);
  }
  onPub('cartUpdate', function () { refreshCart(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  /* The quick Add on cards (auro-cards.js) shows its message when an add worked: use it as the signal. */
  var toastListeners = [];
  function watchToast() {
    var toast = $('[data-ac-toast]');
    if (!toast || toast.dataset.apdpWatch) return;
    toast.dataset.apdpWatch = '1';
    var wasOn = toast.classList.contains('is-on');
    new MutationObserver(function () {
      var on = toast.classList.contains('is-on') && !toast.hidden;
      if (on && !wasOn) {
        var ok = !toast.classList.contains('is-error');
        var words = ($('[data-ac-toast-text]', toast) || toast).textContent || '';
        if (ok) refreshCart();
        toastListeners.forEach(function (fn) { try { fn(ok, words); } catch (e) { /* keep going */ } });
      }
      wasOn = on;
    }).observe(toast, { attributes: true, attributeFilter: ['class', 'hidden'] });
  }

  /* ---------- 1. Goes well with ---------- */
  function initAddons(el) {
    var form = document.getElementById(el.dataset.form);
    if (!form) return;
    var btn = form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
    var span = btn ? btn.querySelector('span') : null;
    var list = $('[data-apdp-addon-list]', el);
    var msg = $('[data-apdp-addon-msg]', el);
    var productId = Number(el.dataset.productId);
    var mainPrice = Number(el.dataset.mainPrice) || 0;
    var count = Number(el.dataset.count) || 3;
    var cartIds = String(el.dataset.cartIds || ',');
    var base = span ? span.textContent.trim() : '';
    var ours = '';
    var busy = false;

    /* The form's id comes from the data attribute: form.id would return the hidden input named "id". */
    var qtyInput = function () { return document.querySelector('input[name="quantity"][form="' + el.dataset.form + '"]') || form.querySelector('input[name="quantity"]'); };
    var qty = function () { var q = qtyInput(); var n = q ? parseInt(q.value, 10) : 1; return n > 0 ? n : 1; };
    var picks = function () { return $$('[data-apdp-addon-input]', el).filter(function (i) { return i.checked && !i.disabled; }); };

    function apply() {
      if (!span) return;
      var cur = span.textContent.trim();
      if (cur !== ours) base = cur;
      var ticked = picks();
      var label = base;
      if (ticked.length && !btn.disabled && btn.getAttribute('aria-disabled') !== 'true') {
        var total = mainPrice * qty();
        ticked.forEach(function (i) { total += Number(i.closest('[data-apdp-addon]').dataset.price) || 0; });
        label = 'Add ' + (qty() + ticked.length) + ' to basket · ' + fmt(total);
      }
      if (span.textContent !== label) { ours = label; span.textContent = label; }
      el.classList.toggle('has-picks', ticked.length > 0);
    }

    function rowHTML(p, v) {
      var uid = 'AddOnC-' + productId + '-' + p.id;
      var src = p.featured_image ? String(p.featured_image) : '';
      if (src) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      return '<li class="apdp-addon" data-apdp-addon data-product-id="' + p.id + '" data-variant-id="' + v.id + '" data-price="' + v.price + '">' +
        '<label class="apdp-addon__media" for="' + uid + '">' + (src ? '<img src="' + esc(src) + '" alt="" width="64" height="64" decoding="async">' : '') + '</label>' +
        '<span class="apdp-addon__body"><a class="apdp-addon__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<span class="apdp-addon__price">' + fmt(v.price) + '</span></span>' +
        '<span class="apdp-addon__pick"><input type="checkbox" class="apdp-addon__input" id="' + uid + '" value="' + v.id + '" data-apdp-addon-input>' +
        '<label class="apdp-addon__toggle" for="' + uid + '"><span class="apdp-addon__tick" aria-hidden="true"></span><span class="apdp-addon__word">Add</span>' +
        '<span class="visually-hidden">' + esc(p.title) + ', ' + fmt(v.price) + '</span></label></span></li>';
    }

    var viewed = false;
    function watchView() {
      if (el.hidden || viewed) return;
      var send = function () {
        if (viewed || el.hidden) return;
        viewed = true;
        track('auro_pdp_addon_view', {
          product_id: productId,
          source: el.dataset.source || 'rules',
          count: $$('[data-apdp-addon]', el).length,
          product_ids: $$('[data-apdp-addon]', el).map(function (r) { return Number(r.dataset.productId); })
        });
      };
      if (!('IntersectionObserver' in window)) { send(); return; }
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); send(); }
      }, { threshold: 0.5 });
      io.observe(el);
    }

    /* Complementary products from Shopify first; the server rows stay when there are none. */
    if (el.dataset.url) {
      fetch(el.dataset.url, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('recommendations ' + r.status); return r.json(); })
        .then(function (data) {
          var found = [];
          (data && data.products || []).forEach(function (p) {
            if (found.length >= count || !p || !p.available || p.id === productId) return;
            var vs = p.variants || [];
            if (vs.length !== 1 || !vs[0].available) return;
            if (cartIds.indexOf(',' + p.id + ',') > -1) return;
            found.push(rowHTML(p, vs[0]));
          });
          if (found.length && !picks().length) {
            list.innerHTML = found.join('');
            el.dataset.source = 'complementary';
            el.hidden = false;
            document.dispatchEvent(new CustomEvent('apdp:addons-ready'));
          }
        })
        .catch(function () { /* keep the rule rows */ })
        .then(function () { watchView(); });
    } else {
      watchView();
    }

    el.addEventListener('change', function (e) {
      var input = e.target.closest('[data-apdp-addon-input]');
      if (!input) return;
      var row = input.closest('[data-apdp-addon]');
      if (row) row.classList.toggle('is-on', input.checked);
      if (msg) msg.hidden = true;
      apply();
    });
    document.addEventListener('change', function (e) { if (e.target === qtyInput()) apply(); });
    document.addEventListener('input', function (e) { if (e.target === qtyInput()) apply(); });
    onPub('variantChange', function (event) {
      var v = event && event.data && event.data.variant;
      if (v && typeof v.price === 'number') mainPrice = v.price;
      setTimeout(apply, 0);
    });
    if (span && 'MutationObserver' in window) {
      new MutationObserver(function () { apply(); }).observe(span, { childList: true, characterData: true, subtree: true });
      new MutationObserver(function () { apply(); }).observe(btn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }

    function fail(text) {
      var pf = form.closest('product-form');
      if (pf && typeof pf.handleErrorMessage === 'function' && pf.dataset.hideErrors !== 'true') pf.handleErrorMessage(text);
      if (msg) { msg.textContent = 'Nothing was added. ' + text; msg.hidden = false; }
    }

    /* One request for the product and the ticked items. Runs before Dawn's own handler and only when something is ticked. */
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      var ticked = picks();
      if (!ticked.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (busy || !btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      busy = true;
      var pf = form.closest('product-form');
      if (pf && typeof pf.handleErrorMessage === 'function') pf.handleErrorMessage();
      if (msg) msg.hidden = true;
      var spinner = pf ? $('.loading__spinner', pf) : null;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      var fd = new FormData(form);
      var main = { id: Number(fd.get('id')), quantity: parseInt(fd.get('quantity'), 10) || qty() };
      var props = {};
      fd.forEach(function (value, key) {
        var m = /^properties\[(.+)\]$/.exec(key);
        if (m && typeof value === 'string' && value !== '') props[m[1]] = value;
      });
      if (Object.keys(props).length) main.properties = props;
      if (fd.get('selling_plan')) main.selling_plan = Number(fd.get('selling_plan'));
      var extra = ticked.map(function (i) { return { id: Number(i.value), quantity: 1 }; });
      var body = { items: [main].concat(extra) };
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      var value = mainPrice * main.quantity;
      ticked.forEach(function (i) { value += Number(i.closest('[data-apdp-addon]').dataset.price) || 0; });

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res || res.status) {
            fail((res && (res.description || res.message)) || 'Sorry, that did not work. Please try again.');
            return;
          }
          track('auro_pdp_addon_add', {
            product_id: productId,
            variant_id: main.id,
            addon_count: extra.length,
            addon_variant_ids: extra.map(function (x) { return x.id; }),
            source: el.dataset.source || 'rules',
            value: Math.round(value) / 100,
            currency: currency
          });
          ticked.forEach(function (i) {
            i.checked = false;
            i.disabled = true;
            var row = i.closest('[data-apdp-addon]');
            if (row) { row.classList.remove('is-on'); row.classList.add('is-added'); var w = $('.apdp-addon__word', row); if (w) w.textContent = 'In basket'; }
          });
          if (!cart) { window.location = (window.routes && window.routes.cart_url) || root + 'cart'; return; }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: String(main.id), cartData: res });
          } else {
            refreshCart();
          }
          if (typeof cart.renderContents === 'function') cart.renderContents(res);
        })
        .catch(function () { fail('Sorry, that did not work. Please check your connection and try again.'); })
        .then(function () {
          busy = false;
          btn.classList.remove('loading');
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          btn.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
          apply();
        });
    }, true);

    cartListeners.push(function (cart) {
      cartIds = ',' + cart.items.map(function (i) { return i.product_id; }).join(',') + ',';
    });
    apply();
  }

  /* ---------- 2. Free delivery nudge ---------- */
  function initFreeDelivery(el) {
    var text = $('[data-apdp-fd-text]', el);
    var threshold = Number(el.dataset.threshold) || 0;
    if (!text || threshold <= 0) return;
    cartListeners.push(function (cart) {
      var total = Number(cart.total_price) || 0;
      var left = threshold - total;
      var html;
      if (!cart.item_count) html = esc(el.dataset.labelCap) + ' on orders over ' + esc(el.dataset.over);
      else if (left > 0) html = '<strong>' + fmt(left) + '</strong> away from ' + esc(el.dataset.label);
      else html = esc(el.dataset.labelCap) + ' on this order';
      if (text.innerHTML !== html) text.innerHTML = html;
      el.classList.toggle('is-done', cart.item_count > 0 && left <= 0);
    });
  }

  /* Adds from card quick Add (and its quick view) on this page count as related adds when they came from that section. */
  var pendingRel = null;
  toastListeners.push(function (ok, words) {
    if (!pendingRel) return;
    var p = pendingRel;
    pendingRel = null;
    if (ok && /added/i.test(words) && Date.now() - p.t < 60000) track('auro_pdp_related_add', { product_id: p.product_id, related_product_id: p.related_product_id, variant_id: p.variant_id, source: p.source });
  });

  /* ---------- 3. You may also like ---------- */
  function initRelated(el) {
    var mainId = Number(el.dataset.productId || 0);
    el.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ac-add], [data-ac-plus], [data-ac-qv]');
      if (!t) return;
      var card = t.closest('[data-ac-card]');
      var item = t.closest('[data-product-id]');
      if (!card || !item) return;
      pendingRel = { t: Date.now(), product_id: currentProductId() || mainId, related_product_id: Number(item.dataset.productId), variant_id: Number(card.dataset.variantId), source: el.hasAttribute('data-apdp-recent') ? 'recently_viewed' : (el.hasAttribute('data-apdp-more') ? 'more_in' : 'related') };
    }, true);
    if (!el.hasAttribute('data-apdp-related')) return;
    near(el, function () {
      fetch(el.dataset.url)
        .then(function (r) { if (!r.ok) throw new Error('related ' + r.status); return r.text(); })
        .then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html');
          var fresh = d.querySelector('[data-apdp-related]');
          if (!fresh || !fresh.querySelector('[data-apdp-related-ready]')) return;
          el.innerHTML = fresh.innerHTML;
          el.classList.add('is-ready');
          if (window.AuroCards && typeof window.AuroCards.sync === 'function') window.AuroCards.sync();
          document.dispatchEvent(new CustomEvent('apdp:related-ready'));
        })
        .catch(function () { /* section stays empty */ });
    });
  }

  function currentProductId() {
    var p = $('product-info[data-product-id]');
    return p ? Number(p.dataset.productId) : 0;
  }

  /* ---------- 4. Recently viewed ---------- */
  function readRecent() {
    try {
      var v = JSON.parse(window.localStorage.getItem(STORE_KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && /^[a-z0-9][a-z0-9_-]*$/i.test(h); }) : [];
    } catch (e) { return []; }
  }
  function writeRecent(list) {
    try { window.localStorage.setItem(STORE_KEY, JSON.stringify(list.slice(0, 9))); } catch (e) { /* private mode or storage full */ }
  }
  function initRecent(el) {
    var handle = el.dataset.handle || '';
    var max = Math.min(8, Math.max(2, Number(el.dataset.count) || 8));
    var before = readRecent();
    var others = before.filter(function (h) { return h !== handle; });
    if (handle) writeRecent([handle].concat(others));
    var want = others.slice(0, max);
    initRelated(el);
    if (want.length < 2) return;
    var list = $('[data-apdp-recent-list]', el);
    /* The section stays hidden until its cards arrive, and hidden elements never intersect: watch a marker instead. */
    var mark = document.createElement('div');
    mark.setAttribute('aria-hidden', 'true');
    mark.style.height = '1px';
    el.parentNode.insertBefore(mark, el);
    near(mark, function () {
      Promise.all(want.map(function (h) {
        return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=auro-rv-card')
          .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
          .then(function (html) {
            var li = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-apdp-rv-item]');
            return li ? li.outerHTML : null;
          })
          .catch(function () { return null; });
      })).then(function (items) {
        var good = [];
        var gone = [];
        items.forEach(function (html, i) { if (html) good.push(html); else gone.push(want[i]); });
        if (gone.length) writeRecent(readRecent().filter(function (h) { return gone.indexOf(h) < 0; }));
        mark.remove();
        if (good.length < 2) return;
        list.innerHTML = good.join('');
        el.hidden = false;
        if (window.AuroCards && typeof window.AuroCards.sync === 'function') window.AuroCards.sync();
      });
    });
  }

  /* ---------- 5. Sticky Add to basket ---------- */
  function cookieBannerOpen() {
    var b = document.getElementById('shopify-pc__banner') || $('.shopify-pc__banner__dialog');
    if (!b) return false;
    var cs = window.getComputedStyle(b);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && b.getClientRects().length > 0 && b.getBoundingClientRect().height > 0;
  }
  function initSticky(el) {
    var main = document.getElementById(el.dataset.button);
    if (!main) return;
    /* Fixed bars inside the animated product column would scroll with it, so the bar lives at the end of <body>.
       A copy left behind by the theme editor re-rendering the section is removed first. */
    $$('body > [data-apdp-sticky]').forEach(function (old) { if (old !== el) old.remove(); });
    if (el.parentNode !== document.body) document.body.appendChild(el);
    var sBtn = $('[data-apdp-sticky-btn]', el);
    var sPrice = $('[data-apdp-sticky-price]', el);
    var sVariant = $('[data-apdp-sticky-variant]', el);
    var mq = window.matchMedia('(max-width: 749px)');
    var allowed = function () { return mq.matches ? !el.classList.contains('apdp-sticky--no-mobile') : el.classList.contains('apdp-sticky--desktop'); };
    var past = false;
    var shown = false;
    var html = document.documentElement;

    function mirror() {
      var span = main.querySelector('span');
      var t = span ? span.textContent.trim() : '';
      if (t.indexOf('·') > -1) t = t.replace(' to basket ·', ' ·');
      if (t && sBtn.textContent !== t) sBtn.textContent = t;
      var off = main.disabled || main.getAttribute('aria-disabled') === 'true';
      sBtn.disabled = main.disabled;
      sBtn.setAttribute('aria-busy', String(!main.disabled && off));
    }
    function update() {
      var show = past && allowed() && !cookieBannerOpen();
      if (show === shown) return;
      shown = show;
      if (show) {
        el.hidden = false;
        html.style.setProperty('--apdp-sticky-h', el.offsetHeight + 'px');
        html.classList.add('apdp-sticky-on');
        requestAnimationFrame(function () { el.classList.add('is-on'); });
      } else {
        el.classList.remove('is-on');
        html.classList.remove('apdp-sticky-on');
        el.hidden = true;
      }
    }
    function measure() {
      var r = main.getBoundingClientRect();
      past = r.bottom < 0;
      update();
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function () { measure(); }).observe(main);
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; measure(); });
    }, { passive: true });
    window.addEventListener('resize', measure);
    if (mq.addEventListener) mq.addEventListener('change', measure);
    sBtn.addEventListener('click', function () {
      if (main.disabled) return;
      main.click();
    });
    new MutationObserver(mirror).observe(main, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'], childList: true, subtree: true, characterData: true });
    onPub('variantChange', function (event) {
      var v = event && event.data && event.data.variant;
      if (!v) return;
      if (sPrice && typeof v.price === 'number') sPrice.textContent = fmt(v.price);
      if (sVariant && v.title) sVariant.textContent = v.title;
    });
    mirror();
    measure();
  }

  /* ---------- 6. Gift box link ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-apdp-gift]');
    if (a) track('auro_pdp_gift_link', { product_id: Number(a.dataset.productId) });
  });

  /* ---------- 7. Breadcrumbs and More in [Collection] ---------- */
  var FROM_KEY = 'auro_pdp_from';
  function readFrom() {
    try {
      var v = JSON.parse(window.sessionStorage.getItem(FROM_KEY) || 'null');
      if (!v || typeof v.c !== 'string' || typeof v.p !== 'string') return null;
      if (!/^[a-z0-9][a-z0-9_-]*$/i.test(v.c) || !/^[a-z0-9][a-z0-9_-]*$/i.test(v.p)) return null;
      if (!v.t || Date.now() - v.t > 2 * 3600 * 1000) return null;
      return v;
    } catch (e) { return null; }
  }
  function writeFrom(c, p) {
    try { window.sessionStorage.setItem(FROM_KEY, JSON.stringify({ c: c, p: p, t: Date.now() })); } catch (e) { /* private mode */ }
  }
  function handleFromHref(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* Leave out what the page already shows (Goes well with, You may also like), then show the first 4 to 8 left. */
  function dedupeMore(el) {
    var list = $('[data-apdp-more-list]', el);
    if (!list) return;
    var seen = {};
    $$('[data-apdp-addons]:not([hidden]) [data-apdp-addon]').forEach(function (r) { seen[r.dataset.productId] = 1; });
    $$('[data-apdp-related] [data-product-id]').forEach(function (r) { seen[r.dataset.productId] = 1; });
    var max = Math.min(8, Math.max(4, Number(el.dataset.count) || 8));
    var shown = 0;
    $$('[data-apdp-more-item]', el).forEach(function (li) {
      var keep = !seen[li.dataset.productId] && shown < max;
      if (keep) shown += 1;
      li.hidden = !keep;
    });
    list.hidden = shown < 4;
  }

  function initMore(el) {
    initRelated(el);
    dedupeMore(el);
    if (!el.dataset.apdpMoreWatch) {
      el.dataset.apdpMoreWatch = '1';
      document.addEventListener('apdp:related-ready', function () { dedupeMore(currentMore() || el); });
      document.addEventListener('apdp:addons-ready', function () { dedupeMore(currentMore() || el); });
    }
  }
  function currentMore() { return $('[data-apdp-more]'); }

  /* Came from a collection page card: re-render through that collection, if the server accepts it (not hidden). */
  function switchCollection() {
    var crumbs = $('[data-apdp-crumbs]');
    var more = currentMore();
    var handle = (crumbs && crumbs.dataset.productHandle) || (more && more.dataset.handle) || '';
    var current = (crumbs && crumbs.dataset.collection) || (more && more.dataset.collection) || '';
    var from = readFrom();
    if (!handle || !from || from.p !== handle || from.c === current) return;
    var sid = more ? more.dataset.section : 'auro-more-in';
    fetch(root + 'collections/' + encodeURIComponent(from.c) + '/products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(sid))
      .then(function (r) { if (!r.ok) throw new Error('more ' + r.status); return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-apdp-more]');
        if (!fresh || fresh.dataset.collection !== from.c) return;
        if (crumbs) {
          var a = $('[data-apdp-crumb-coll]', crumbs);
          if (a) {
            a.textContent = fresh.dataset.label;
            a.setAttribute('href', fresh.dataset.url);
            a.closest('li').hidden = false;
            crumbs.dataset.collection = from.c;
          }
        }
        var live = currentMore();
        if (live) {
          live.innerHTML = fresh.innerHTML;
          ['collection', 'label', 'url'].forEach(function (k) { live.dataset[k] = fresh.dataset[k]; });
          dedupeMore(live);
          if (window.AuroCards && typeof window.AuroCards.sync === 'function') window.AuroCards.sync();
        }
      })
      .catch(function () { /* keep the server's choice */ });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var link = e.target.closest('[data-apdp-cat-click]');
    var type = link ? link.dataset.apdpCatClick : '';
    var more = e.target.closest('[data-apdp-more]');
    if (!link && more) {
      var a = e.target.closest('a[href]');
      if (a && a.closest('[data-apdp-more-item]') && !a.closest('[data-ac-qv]')) { link = a; type = 'card'; }
    }
    if (!link) return;
    var crumbs = link.closest('[data-apdp-crumbs]');
    var coll = (more && more.dataset.collection) || (crumbs && crumbs.dataset.collection) || '';
    if (type === 'card' && coll) {
      var next = handleFromHref(link.getAttribute('href'));
      if (next) writeFrom(coll, next);
    }
    track('auro_pdp_category_click', { type: type, product_id: currentProductId(), collection: coll, url: link.getAttribute('href') || '' });
  });

  function init(scope) {
    watchToast();
    $$('[data-apdp-addons]', scope).forEach(function (el) { if (!el.dataset.apdpInit) { el.dataset.apdpInit = '1'; initAddons(el); } });
    $$('[data-apdp-fd]', scope).forEach(function (el) { if (!el.dataset.apdpInit) { el.dataset.apdpInit = '1'; initFreeDelivery(el); } });
    $$('[data-apdp-related]', scope).forEach(function (el) { if (!el.dataset.apdpInit) { el.dataset.apdpInit = '1'; initRelated(el); } });
    $$('[data-apdp-recent]', scope).forEach(function (el) { if (!el.dataset.apdpInit) { el.dataset.apdpInit = '1'; initRecent(el); } });
    $$('[data-apdp-more]', scope).forEach(function (el) { if (!el.dataset.apdpInit) { el.dataset.apdpInit = '1'; initMore(el); } });
    $$('[data-apdp-sticky]', scope).forEach(function (el) { if (!el.dataset.apdpInit) { el.dataset.apdpInit = '1'; initSticky(el); } });
  }
  function start() {
    init(document);
    switchCollection();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();